// extracted by mini-css-extract-plugin
module.exports = {"Bg":"Hero__Bg_Rx201","Wrapper":"Hero__Wrapper_1QfRl container","Title":"Hero__Title_3LPPH","Lead":"Hero__Lead_TA_sL grid","Factoids":"Hero__Factoids_3An-U"};